import React, { useState } from 'react';
import Tab from 'react-bootstrap/Tab';
import Nav from 'react-bootstrap/Nav';
import Problema from '../../../../assets/images/wifi-sinal.png';
import Foto1 from '../../../../assets/images/Cobertura-WiFi-1.jpg';
import Foto2 from '../../../../assets/images/Capacidade-WiFi-2.jpg'; // Suponha que você tenha esta imagem
import Foto3 from '../../../../assets/images/Confiabilidade-WiFi-3.jpg'; // Suponha que você tenha esta imagem

import 'bootstrap/dist/css/bootstrap.min.css';
import * as BiIcons from "react-icons/bi";

import Cobertura from './Cobertura/Cobertura';
import Capacidade from './Capacidade/Capacidade';
import Confiabilidade from './Confiabilidade/Confiabilidade';

function Problemas() {
  const [activeTab, setActiveTab] = useState('/cobertura');
  const [currentImage, setCurrentImage] = useState(Foto1);

  const handleTabSelect = (selectedTab) => {
    setActiveTab(selectedTab);
    switch (selectedTab) {
      case '/cobertura':
        setCurrentImage(Foto1);
        break;
      case '/capacidade':
        setCurrentImage(Foto2);
        break;
      case '/confiabilidade':
        setCurrentImage(Foto3);
        break;
      default:
        setCurrentImage(Foto1);
    }
  };

  return (
    <>
      <div className='container-fluid'>
        <div className='row'>
          <div className='col-sm-12 col-md-6'>
            {/* <h1>Principais problemas</h1> */}
            <img src={Problema} alt='problema' className='w-100 mb-0' />

            <Tab.Container activeKey={activeTab} onSelect={handleTabSelect}>
              <Nav fill variant="tabs">
                <Nav.Item>
                  <Nav.Link eventKey="/cobertura">
                    <div className='aba-menu'>
                      <h4><BiIcons.BiRss /></h4>
                      <h5>Cobertura</h5>
                    </div>
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="/capacidade">
                    <div className='aba-menu'>
                      <h4><BiIcons.BiRss /></h4>
                      <h5>Capacidade</h5>
                    </div>
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="/confiabilidade">
                    <div className='aba-menu'>
                      <h4><BiIcons.BiRss /></h4>
                      <h5>Confiabilidade</h5>
                    </div>
                  </Nav.Link>
                </Nav.Item>
              </Nav>
              <Tab.Content className='container'>
                <Tab.Pane eventKey="/cobertura">
                  <Cobertura />
                </Tab.Pane>
                <Tab.Pane eventKey="/capacidade">
                  <Capacidade />
                </Tab.Pane>
                <Tab.Pane eventKey="/confiabilidade">
                  <Confiabilidade />
                </Tab.Pane>
              </Tab.Content>
            </Tab.Container>
          </div>
          <div className='col-sm-12 col-md-6'>
            <div className='imagem'>
              <img className="d-block w-100" src={currentImage} alt="Current slide" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Problemas;
